import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import * as moment from 'jalali-moment';

@Injectable({
  providedIn: 'root'
})
export class ToolService {

  constructor(private toast: ToastController) {
    moment.locale('fa', { useGregorianParser: true });
  }

  public ConvertToPersianDate(ForeignDate){
    return moment(ForeignDate).format('YYYY/MM/DD');
  }

  public ConvertToPersianDateTime(ForeignDateTime){
    return moment(ForeignDateTime).format('HH:mm:ss YYYY/MM/DD');
  }

  public IsNationalCodeValid(input) {
    if (!/^\d{10}$/.test(input))
        return false;
 
    var check = parseInt(input[9]);
    var sum = 0;
    var i;
    for (i = 0; i < 9; ++i) {
        sum += parseInt(input[i]) * (10 - i);
    }
    sum %= 11;
 
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
  }

  public IsPhoneNumberValid(input){
    return /^(\+98|0)?9\d{9}$/.test(input);
  }

  public async DangerToast(msg) {
    const toast = await this.toast.create({
      message: msg,
      animated: true,
      color:"danger",
      duration:2500,
      cssClass:"rtl"
    });
    toast.present();
  }

  public async PrimaryToast(msg) {
    const toast = await this.toast.create({
      message: msg,
      animated: true,
      color:"primary",
      duration:2500,
      cssClass:"rtl"
    });
    toast.present();
  }

  public async SuccessToast(msg) {
    const toast = await this.toast.create({
      message: msg,
      animated: true,
      color:"success",
      duration:2500,
      cssClass:"rtl"
    });
    toast.present();
  }

  public async WarningToast(msg) {
    const toast = await this.toast.create({
      message: msg,
      animated: true,
      color:"warning",
      duration:2500,
      cssClass:"rtl"
    });
    toast.present();
  }

  ChangeTheme(IsDark){
    document.body.classList.toggle('dark', IsDark);
    localStorage.setItem("Theme", IsDark ? "dark" : "light");
  }

}
